<template>
  <v-row no-gutters class="fill-height">
    <crud-factory :serviceName="serviceName" :crudDialog="crudDialog" />
  </v-row>
</template>

<script>
export default {
  components: {
    crudFactory: () => import("./CrudFactory"),
  },
  data() {
    return {
      serviceName: "objectius",
      crudDialog: {
        large: false,
        createTitle: "Nou objectiu",
        modelKeyTitle: "nom",
      },
    }
  },
}
</script>

<style lang="scss" scoped />
